'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';
import air from '@/public/images/services/air_conditioning/air.png';
import control from '@/public/images/services/air_conditioning/control.png';
import energy from '@/public/images/services/air_conditioning/energy.png';
import time from '@/public/images/services/ac_installation/time.png';
import service from '@/public/images/services/heating/service.png';
import installationImage from '@/public/images/services/heating-installation/installation-proccess.jpg';

const data = {
  title: 'Professional Heating Maintenance Services',
  description:
    'Annual heating maintenance is the minimum to make sure your system is optimized. At Tytum, we perform seasonal tune-ups, furnace maintenance, and HVAC inspections so we can catch any issues early on.',
  image: installationImage,
  offer_title: '',
  offer_data: [
    {
      title: 'Furnace Maintenance & Tune-Ups',
      description:
        'Do you need furnace maintenance in San Diego that will be comprehensive and reasonably priced? The way we perform a furnace tune-up in San Diego involves several steps, such as:',
      list: [
        {
          title: 'Cleaning the entire system',
          description: '',
        },
        {
          title: 'Checking the airflow',
          description: '',
        },
        {
          title: 'Furnace inspection for any loose or worn-out parts',
          description: '',
        },
        {
          title: 'Safety inspections',
          description: '',
        },
      ],
      footerText:
        'Gas furnace maintenance requires specific expertise, and our certified technicians can perform it safely.',
    },
    {
      title: 'HVAC System Maintenance',
      description:
        'HVAC maintenance in San Diego is performed to prevent sudden malfunctions that can be more expensive than you expect. To make sure this doesn’t happen, we do the following:',
      list: [
        {
          title: 'Optimize airflow so it’s even and strong enough',
          description: '',
        },
        {
          title:
            'Improve the efficiency of the system by finding any loose or broken parts',
          description: '',
        },
        {
          title: 'Calibrate the thermostat',
          description: '',
        },
        {
          title: 'Clean the system',
          description: '',
        },
      ],
      footerText:
        'With our HVAC maintenance services in San Diego, you won’t suddenly have a non-working system in the middle of winter.',
    },
    {
      title: 'Residential Heating Maintenance',
      description:
        'When performing home heating maintenance, we are focused on energy efficiency, reducing breakdown risks, and also expanding the lifespan of your system. Our home heating maintenance in San Diego is perfect for homeowners who want their system to last them for many years.',
      list: [],
    },
  ],
  banner_title: 'Do you need seasonal heating tune-ups?',
  banner_description:
    'Contact our experienced HVAC technicians and get fast scheduling!',
  banner_with_button: true,
  why_title: '',
  why_description: '',
  why_items: [],
  why_footerText: '',
  extraContent: [
    {
      title: 'Why Regular Heating Maintenance Matters',
      description:
        'Installing a heating system and forgetting about it is not enough if you want it to work for many years. Here’s why regular maintenance is highly important.',
      image: null,
      items: [
        {
          title: 'Prevent Costly Breakdowns',
          description:
            'Regular system and home furnace maintenance allows you to replace small parts or fix minor problems before you have to invest higher costs in a major overhaul. ',
          image: null,
        },
        {
          title: 'Improve Energy Efficiency',
          description:
            'A clean and properly lubricated heating system reduces your energy bills. Any problems with your HVAC system will negatively affect the energy efficiency of your home.',
          image: null,
        },
        {
          title: 'Extend Furnace Lifespan',
          description:
            'When a heating system struggles to work to its full potential, it will wear out earlier than it should. You can significantly extend the furnace’s lifespan with regular maintenance.',
          image: null,
        },
        {
          title: 'Maintain Indoor Comfort',
          description:
            'The main goal of any system is to make you feel comfortable in your space temperature-wise. And this can only be achieved when the entire system runs without a single hiccup.',
          image: null,
        },
        {
          title: 'Keep Your System Safe',
          description:
            'Regular inspections are needed for a gas furnace to run safely. This is important for preventing carbon monoxide leaks in your house, which can be extremely dangerous or even fatal.',
          image: null,
        },
      ],
      footerText: '',
    },
    {
      title: 'Signs Your Heating System Needs Maintenance',
      description:
        'If your system shows these warning signs, professional heating system maintenance can restore reliability and comfort before the issue grows.',
      image: null,
      items: [
        {
          title: 'Uneven Heating',
          description:
            'You may notice that the air is way too hot in some rooms, while in others, you feel a cool breeze. This is one of the most noticeable signs, and it can be fixed with a heating tune-up in San Diego.',
          image: control,
        },
        {
          title: 'Strange Noises',
          description:
            'Strange noises in your heating system can point to some parts getting loose, filters getting clogged, etc. Whenever this happens, we recommend that you don’t postpone maintenance so the situation doesn’t progress.',
          image: service,
        },
        {
          title: 'Higher Energy Bills',
          description:
            'If you use your heating system as usual but your bills are higher than normal, it means that there is energy loss taking place, and it’s best to get your system checked.',
          image: energy,
        },
        {
          title: 'Weak Airflow',
          description:
            'Poor airflow will immediately affect how well the temperature is regulated in your house. We can find the cause of the weak airflow as part of our HVAC maintenance.',
          image: air,
        },
        {
          title: 'Frequent Cycling',
          description:
            'Do you notice that the heater switches on and off too often? There can be different reasons, including the wearing out of parts, and our Tytum team works quickly to discover why this happens.',
          image: time,
        },
      ],
      footerText: '',
      /* banner: {
        title: 'Do you need seasonal heating tune-ups?',
        description:
          'Contact our experienced HVAC technicians for fast scheduling and dependable residential service across San Diego.',
        withButton: true,
      }, */
    },
    {
      title: 'What’s Included in a Heating Tune-Up?',
      description:
        'When you order heating system maintenance, we perform the following:',
      image: null,
      list: [
        {
          title: 'Thoroughly inspect the entire system for any problems',
          description: '',
        },
        {
          title:
            'Test the thermostat to see whether it determines the temperature and responds to it',
          description: '',
        },
        {
          title:
            'Check/clean/replace filters depending on the conditions they are in',
          description: '',
        },
        {
          title: 'Perform airflow testing to see if it is sufficient',
          description: '',
        },
        {
          title: 'Check all the electrical components of the system',
          description: '',
        },
        {
          title:
            'As part of furnace inspection, we thoroughly clean the burners',
          description: '',
        },
        {
          title:
            'HVAC tune-up also includes safety checks, so there is no gas leaking or other dangerous issues',
          description: '',
        },
      ],
      items: [],
      // footerText:
      //   'This structured process helps keep your heating system maintenance proactive instead of reactive.',
    },
    {
      title: 'Heating Maintenance for San Diego Homes',
      description:
        'Heater maintenance in San Diego has its peculiarities. Even though the winters are fairly mild in the area, the coastal climate offers its challenges. For example, high humidity and more corrosion-related risks. At Tytum, we ensure your residential HVAC system is as energy efficient as it can be, and we prepare it for different seasons.',
      image: null,
      items: [],
      footerText: '',
    },
    {
      title: 'Why Choose Tytum?',
      description:
        'Here are some of the reasons to choose Tytum as your provider.',
      image: null,
      items: [
        {
          title: '1. Experienced HVAC Technicians',
          description:
            'At Tytum, we have over 20 years of experience installing and maintaining heating systems.',
          image: null,
        },
        {
          title: '2. Fast Scheduling',
          description:
            'You can contact our Tytum team quickly by phone or online form to schedule your appointment without any delays.',
          image: null,
        },
        {
          title: '3. Reliable Residential Service',
          description:
            'You can rely on our team to perform reliable maintenance. We have a certified team and are fully licensed in California.',
          image: null,
        },
        {
          title: '4. Transparent Pricing',
          description:
            'We don’t hide costs for our maintenance services, so you can always find out the exact price for servicing your heating system.',
          image: null,
        },
        {
          title: '5. Preventive Maintenance Expertise',
          description:
            'Our Tytum technicians have performed numerous HVAC and furnace check-ups over the years, so we have expertise in the matter. ',
          image: null,
        },
        {
          title: '6. Customer Satisfaction Focus',
          description:
            'We have a customer-oriented approach when it comes to everything from scheduling appointments to suggesting solutions for heating problems.',
          image: null,
        },
      ],
      footerText: '',
    },
    /*  {
      title: 'More of Our Services',
      description:
        'In addition to heating maintenance, we provide complete HVAC support for comfort in every season.',
      image: null,
      items: [],
      footerText:
        '<a href="https://tytum.com/services/heating-and-air/heating-installation">Heating System Installation</a><br /><a href="https://tytum.com/services/heating-and-air/heating">Heating & Furnace Repair</a><br /><a href="https://tytum.com/services/heating-and-air/air-conditioning">Air Conditioning Service & Repair</a><br /><a href="https://tytum.com/services/heating-and-air/cooling-and-heating">Ductless Air Conditioning Service & Repair</a><br /><a href="https://tytum.com/services/heating-and-air/ductless-ac-installation">Mini Split Air Conditioner Installers</a>',
    }, */
    {
      title: 'Frequently Asked Questions (FAQ)',
      description: '',
      image: null,
      items: [
        {
          title:
            '✓ How quickly can I get furnace maintenance near me in San Diego?',
          description:
            'You can schedule a furnace tune-up on the same day or the next one. This way, we can help you even when there is an emergency. Depending on how complex your system is, an appointment takes around 1–2 hours.',
          image: null,
        },
        {
          title:
            '✓ Why should I schedule a furnace check at least once a year?',
          description:
            'As experts in furnace inspection in San Diego, we recommend that the furnace be checked at least once a year to increase its lifespan. But, most importantly, if you have a gas furnace, this is a matter of safety, as we need to check it for leaks.',
          image: null,
        },
        {
          title: '✓ Do you also offer heating installation or repairs?',
          description:
            'Yes. You can contact us if you need a new heating system installed or if yours needs repairs. We can also expand an existing heating system if needed. Our team covers all HVAC-related services, including mini-split installation, AC installation, etc.',
          image: null,
        },
      ],
      footerText: '',
    },
  ],
};

const HeatingMaintenancePage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="snowCircle">
        <MainSection
          label="Service Details"
          title="Heating Maintenance in San Diego"
          description="With the help of heating maintenance services in San Diego, many problems with the HVAC system and furnaces can be prevented. At Tytum, we perform expert furnace tune-up near you and heating maintenance in San Diego for residential heating systems. Thanks to our HVAC tune-up in San Diego, you can be confident that your house is ready for any weather conditions."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={<ContentV2 data={data} />}
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default HeatingMaintenancePage;
